import { Entity } from '..'

export class ConcessionaireDetails extends Entity {
  type: string
  value: string
  idModel: number
}
